import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import aa96891aeb545b938c40fe3e33acfe6a6b from "./generated-c7d9b528-ed64-4d36-8032-ae955ed2fd1a.json";

import ab292f2d76487b213b0aa80f997a890a6b from "./generated-b3bfded6-db14-48ed-a158-edecfce05050.json";

import a8a9157930c0e2338ed06bc7dd9d090a9b from "./generated-b2bfc2c9-53ce-4bd2-ba20-797e6493aac6.json";

import aa2b7f614b7b6432e294fb55360a62664b from "./generated-9250458c-ca4c-47f7-8181-9855a19a780e.json";

import a069c7308acab93f53ea8f9d4e5223874b from "./generated-19385ae8-85aa-4de4-9dc5-7e9adb3150c7.json";

import a53fb27075a4609f5a17ceb848ff7e0ceb from "./generated-309114a7-69c0-4264-9ab6-67837e7274a7.json";

import a56a7137ae29c190bf1abce0ee5eb86e6b from "./generated-900fbb59-7ba8-4be0-bcec-6d8ff69ff9e7.json";

import a598285090bd1e515db8ee767744f09ceb from "./generated-5c0724f8-2517-41d2-8ca8-1fdc2785a49c.json";

import a057e948e6a012c9e54f653fbefe6b1e7b from "./generated-d0b0fda6-4e8c-4ce8-9b41-eedc9d16c4fe.json";

import ae86f25946c2fa304b09bde67c9dd9404b from "./generated-065c4ab3-d00f-47ff-9d7d-b6de339d7427.json";

import a35aadf7f8b9694b05af8cdeeb88f47c8b from "./generated-eff064d1-7a4c-4fa4-b1a2-1a7553f83479.json";

import ac101cdee3112bd2f26980bbf3bbadc7eb from "./generated-4e1fe0af-5d8c-4abe-b22d-fbc222fc530e.json";

import a3d91ba55323e1933c31a19d5bf05006db from "./generated-8e0eff34-5b15-4282-8cea-f9713deb5979.json";

import a330858071f9afbac4745a5bf7b66f4dab from "./generated-9fcf83b7-57f5-4ab1-83d6-d6758b8a8d2e.json";

import ae38cb160eff8e994987cd8e907f73cb8b from "./generated-65e28539-f23a-451f-b852-9b3656af08d9.json";

import a5ea0d9ccf1a47d99cba3203b1a65c588b from "./generated-972e8b25-123f-41eb-a6ec-4124abd54c9f.json";

import ad7add383c4d5f85c9d819f2fb3731bfbb from "./generated-e1b51ee9-8139-4c75-a2be-c3353751a51e.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(aa96891aeb545b938c40fe3e33acfe6a6b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(ab292f2d76487b213b0aa80f997a890a6b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a8a9157930c0e2338ed06bc7dd9d090a9b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(aa2b7f614b7b6432e294fb55360a62664b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a069c7308acab93f53ea8f9d4e5223874b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a53fb27075a4609f5a17ceb848ff7e0ceb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a56a7137ae29c190bf1abce0ee5eb86e6b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a598285090bd1e515db8ee767744f09ceb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a057e948e6a012c9e54f653fbefe6b1e7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(ae86f25946c2fa304b09bde67c9dd9404b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a35aadf7f8b9694b05af8cdeeb88f47c8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ac101cdee3112bd2f26980bbf3bbadc7eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a057e948e6a012c9e54f653fbefe6b1e7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a3d91ba55323e1933c31a19d5bf05006db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a330858071f9afbac4745a5bf7b66f4dab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a057e948e6a012c9e54f653fbefe6b1e7b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(ae38cb160eff8e994987cd8e907f73cb8b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a5ea0d9ccf1a47d99cba3203b1a65c588b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(ad7add383c4d5f85c9d819f2fb3731bfbb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(ae38cb160eff8e994987cd8e907f73cb8b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */